// Peças compartilhadas dos controles de formulário (DS-04/DS-06): mesma altura, borda de controle (≥ 3:1) e foco.
// Tudo por token semântico; `focus-visible:outline-hidden` troca o contorno do navegador pelo anel e, em `forced-colors` (alto contraste do
// Windows), deixa um contorno só no foco. O `outline-hidden` sem prefixo desenharia o contorno o tempo todo nesse modo.
export const controlSurface =
  'rounded-control border border-border-control bg-surface text-foreground transition-colors focus-visible:outline-hidden placeholder:text-muted-foreground';
export const controlFocus =
  'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring';
export const controlInvalid = 'aria-invalid:border-danger aria-invalid:ring-danger';
export const controlDisabled = 'disabled:cursor-not-allowed disabled:opacity-50';
/** Anel de foco para elementos que não são campo (botão, aba, caixa de seleção…). */
export const focusRing =
  'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background';
